import { motion } from 'framer-motion'
import React from 'react'
import tw from 'twin.macro'

import { ProductListCard } from '../components/ProductListingCard'
// import { Link } from "gatsby";
// import styled from "styled-components";
// import { globalHistory } from "@reach/router";
import Pagination from './Pagination'

// import CategoryComponent from "./CategoryComponent";

// const CategoryContainer = tw.div`hidden md:block md:w-1/6`;
//
// const CategoryLabelTitle = tw.h1`tracking-wider text-lg text-gray-500 mb-4 uppercase`;
// const CategoryTitleContainer = tw.div`mb-2`;
// const CategoryTitle = tw.h2`text-gray-900 text-lg tracking-wide cursor-pointer hover:text-green-500 leading-8`;
// const CategoryTitleActive = styled(CategoryTitle)`
//   ${tw`text-green-500 pb-1 border-b-2 border-transparent border-green-500 font-bold`}
// `;

const MainContainer = tw.div`w-full md:w-5/6 px-8 min-h-3/4-screen`
const TabContent = tw(
  motion.div
)`flex flex-wrap -mx-4 overflow-hidden items-start`

function ProductListing({ data, pageContext, isSearch }) {
  return (
    <MainContainer>
      <TabContent>
        {data.length > 0 ? (
          data.map((n) => (
            <ProductListCard
              product={n}
              key={n.id + Math.floor(Math.random() * 100)}
            />
          ))
        ) : (
          <h1 className="pl-4 text-lg font-semibold leading-wide">No products found...</h1>
        )}
      </TabContent>
      {!isSearch && <Pagination pageContext={pageContext} />}
    </MainContainer>
  )
}

export default ProductListing
